import { render, staticRenderFns } from "./wideCard.vue?vue&type=template&id=0f0ce776&scoped=true"
import script from "./wideCard.vue?vue&type=script&lang=ts"
export * from "./wideCard.vue?vue&type=script&lang=ts"
import style0 from "./wideCard.vue?vue&type=style&index=0&id=0f0ce776&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0ce776",
  null
  
)

export default component.exports